<template>
  <el-dialog
    :title="$t('posts.dialog.draftPortalSelectionTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    append-to-body
    :close-on-click-modal="false"
    @close="onCancel"
  >
    <span>{{ dialogText }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel">{{ $t('posts.dialog.cancel') }}</el-button>
      <el-button type="warning" @click="onClear">{{ $t('posts.dialog.draftPortalSelectionClear') }}</el-button>
      <el-button type="primary" @click="onKeep">{{ $t('posts.dialog.draftPortalSelectionKeep') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ElButton from '@/components/Button'

export default {
  name: 'DialogDraftPortalSelection',
  components: { ElButton },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    postCount: {
      type: Number,
      default: 1
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    },
    dialogText () {
      if (this.postCount > 1) {
        return this.$t('posts.dialog.draftPortalSelectionText_plural')
      }
      return this.$t('posts.dialog.draftPortalSelectionText')
    }
  },
  methods: {
    onCancel () {
      this.$emit('cancel')
      this.$emit('update:visible', false)
    },
    onKeep () {
      this.$emit('keep')
    },
    onClear () {
      this.$emit('clear')
    }
  }
}
</script>
